import { render, staticRenderFns } from "./TalkChannelAction.vue?vue&type=template&id=63fa7bd4&"
import script from "./TalkChannelAction.vue?vue&type=script&lang=js&"
export * from "./TalkChannelAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports